import Vue from 'vue'
import Vuex from 'vuex'
import common from '@/utils/common'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    count: 2,
    AUTH_TOKEN: '',
    dictList: [],
    wechatUser: { openId: '', headImgUrl: '', nickName: '' }
  },
  mutations: {
    increment: function (ss) {
      ss.count++
    },
    decrement: function (ss) {
      ss.count--
    },
    setToken: function (state, token) {
      state.AUTH_TOKEN = token
    },
    setWechatUser: function (state, wechatUser) {
      state.wechatUser = wechatUser;
    },
    getAllDict: function (ss) {
      let _ss = ss
      common.getDictList(null, function (data) {
        _ss.dictList = data.page.rows
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/vuex/index.js